/* =================== ANIMAÇÕES GSAP — HOME =================== */
(function () {
  if (typeof gsap === "undefined") {
    console.warn("GSAP não carregado — animações da Home ignoradas.");
    return;
  }
  gsap.registerPlugin(ScrollTrigger);

  window.addEventListener("load", function () {
    const reduz = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduz) return;

    // Reveal genérico (fade-up) para qualquer .gsap-reveal
    gsap.utils.toArray(".gsap-reveal").forEach(function (el) {
      const delay = parseFloat(el.getAttribute("data-gsap-delay")) || 0;
      gsap.from(el, {
        scrollTrigger: { trigger: el, start: "top 88%", toggleActions: "play none none none" },
        y: 40, opacity: 0, duration: 0.8, delay: delay, ease: "power2.out"
      });
    });

    // Fade-right / fade-left (seção Sobre)
    gsap.utils.toArray(".gsap-reveal-right").forEach(function (el) {
      gsap.from(el, {
        scrollTrigger: { trigger: el, start: "top 85%" },
        x: -50, opacity: 0, duration: 0.9, ease: "power2.out"
      });
    });
    gsap.utils.toArray(".gsap-reveal-left").forEach(function (el) {
      gsap.from(el, {
        scrollTrigger: { trigger: el, start: "top 85%" },
        x: 50, opacity: 0, duration: 0.9, ease: "power2.out"
      });
    });

    // Cards de serviço — stagger
    if (document.querySelector(".servicos-home .servico-card-wrapper")) {
      gsap.from(".servicos-home .servico-card-wrapper", {
        scrollTrigger: { trigger: ".servicos-home", start: "top 80%" },
        y: 40, opacity: 0, duration: 0.7, stagger: 0.12, ease: "power2.out"
      });
    }

    // Passos da metodologia — stagger
    if (document.querySelector(".metodologia-step-wrapper")) {
      gsap.from(".metodologia-step-wrapper", {
        scrollTrigger: { trigger: ".metodologia-steps", start: "top 80%" },
        x: 30, opacity: 0, duration: 0.6, stagger: 0.15, ease: "power2.out"
      });
    }

    // Depoimentos — stagger
    if (document.querySelector(".depoimento-card-wrapper")) {
      gsap.from(".depoimento-card-wrapper", {
        scrollTrigger: { trigger: ".depoimentos-grid", start: "top 82%" },
        y: 40, opacity: 0, duration: 0.7, stagger: 0.12, ease: "power2.out"
      });
    }

    // Logos dos clientes — stagger
    if (document.querySelector(".carrossel-clientes .cliente-logo")) {
      gsap.from(".carrossel-clientes .cliente-logo", {
        scrollTrigger: { trigger: ".home-clientes", start: "top 85%" },
        y: 30, opacity: 0, duration: 0.6, stagger: 0.08, ease: "power2.out"
      });
    }

    // Garante o recálculo do ScrollTrigger
    ScrollTrigger.refresh();
  });
})();
